import React from "react";

import destination_1 from "../../public/wheretogo-sumava/vitkuvhradek/destination_1.png";
import destination_2 from "../../public/wheretogo-sumava/vitkuvhradek/destination_2.png";
import destination_3 from "../../public/wheretogo-sumava/vitkuvhradek/destination_3.png";
import destination_4 from "../../public/wheretogo-sumava/vitkuvhradek/destination_4.png";
import destination_5 from "../../public/wheretogo-sumava/vitkuvhradek/destination_5.png";

import destinationIcon_1 from "../../public/wheretogo-sumava/vitkuvhradek/icon_1.png";
import destinationIcon_2 from "../../public/wheretogo-sumava/vitkuvhradek/icon_2.png";
import destinationIcon_3 from "../../public/wheretogo-sumava/vitkuvhradek/icon_3.png";
import destinationIcon_4 from "../../public/wheretogo-sumava/vitkuvhradek/icon_4.png";

import { useContext } from "react";
import { DarkModeContext } from "../../components/DarkModeProvider";

const VitkuvHradek = () => {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={`destinations ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__container">
            <img src={destination_1} alt="" />
            <h1>Vítkuv Hrádek</h1>
            <p>
              Zřícenina Vítkova hradu leží v jížní části Čech a tyčí se do výšky
              1035 m.n.m. Je to také nejvýše položený hrad v Česku. Vítkův Hrádek
              byl založen v polovině 13. století Vítkem z Krumlova jako správní
              a obranné středisko nově osídlené oblasti.
            </p>
          </div>
        </div>
      </section>

      <section className={`destinations__icons ${darkMode ? "dark" : "light"}`}>
        <div className="container">
          <div className="destinations__icons--container">
            <div className="destinations__icon">
              <img src={destinationIcon_1} alt="" />
              <p>turistické trasy</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_2} alt="" />
              <p>horské kolo</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_3} alt="" />
              <p>nádherné výhledy</p>
            </div>
            <div className="destinations__icon">
              <img src={destinationIcon_4} alt="" />
              <p>vysílací věž</p>
            </div>
          </div>
        </div>
      </section>

      <section
        className={`destinations__attractions ${darkMode ? "dark" : "light"}`}
      >
        <div className="container">
          <div className="destinations__attractions--container">
            <div className="destinations__attractions--image">
              <img className="destination_1" src={destination_2} alt="" />
              <img className="destination_2" src={destination_3} alt="" />
              <img className="destination_3" src={destination_4} alt="" />
              <img className="destination_4" src={destination_5} alt="" />
            </div>
            <div className="destinations__attractions--content">
              <h2>Zajímavosti</h2>
              <ul>
                <li>
                  Vítkův kámen se stal inspirací pro různé malíře a spisovatele
                  jako např.: Adalbert Stifter,Adolf Heyduk ...
                </li>
                <li>
                  Tento nejvýše položený hrad ČR držel svůj primát již za
                  Československa, neboť nejvýše položený slovenský hrad
                  (Liptovský hrad) leží o 21 m níže.
                </li>
                <li>
                  Za dobrého počasí lze z vrcholu zhlédnout panorama rakouských
                  Alp s masivy Velkého Prielu, Dachsteinu a Watzmanu i velkolepý
                  výhled do vltavského údolí a českého vnitrozemí.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default VitkuvHradek;
